import { useState } from 'react';
import { C } from '../styles/colours.js';
import { PRICES } from '../stripe.js';
import { supabase } from '../supabase.js';

function Pricing({ onClose, onSelect }) {
  const [loading, setLoading] = useState(null);

  const handlePay = async (planId) => {
    setLoading(planId);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const userEmail = session?.user?.email || '';

      const res = await fetch('https://tabliq-server-production.up.railway.app/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ priceId: PRICES[planId], planId, userEmail }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Something went wrong. Please try again.');
        setLoading(null);
      }
    } catch (err) {
      alert('Payment error. Please try again.');
      setLoading(null);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(7,7,26,0.98)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 999, padding: '20px', fontFamily: 'sans-serif', overflowY: 'auto' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>

        {/* Close */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
          <button onClick={onClose} style={{ background: C.card, border: 'none', color: C.textSub, padding: '8px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 15 }}>✕ Close</button>
        </div>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 64, height: 64, borderRadius: 16, background: 'linear-gradient(145deg, #e8526a, #c0392b)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: 26, margin: '0 auto 14px', color: '#fff' }}>TQ</div>
          <div style={{ fontSize: 22, fontWeight: 900, color: C.white, marginBottom: 6 }}>Go Unlimited</div>
          <div style={{ fontSize: 15, color: C.textSub, lineHeight: 1.6 }}>Free covers up to 6 players.<br/>Unlock unlimited for bigger games.</div>
        </div>

        {/* Free — current plan (not purchasable) */}
        <div style={{ background: C.card, border: `2px solid ${C.green}40`, borderRadius: 16, padding: '16px 18px', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ fontSize: 28, flexShrink: 0 }}>🆓</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.white }}>Free</div>
            <div style={{ fontSize: 15, color: C.textSub, marginTop: 2 }}>Up to 6 players · unlimited games</div>
          </div>
          <div style={{ fontSize: 13, color: C.green, fontWeight: 700, background: `${C.green}15`, padding: '4px 10px', borderRadius: 20 }}>Your plan</div>
        </div>

        {/* Event Pass — £3.99 one-off */}
        <div onClick={() => !loading && handlePay('event')} style={{ background: C.card, border: `2px solid ${C.green}50`, borderRadius: 16, padding: '16px 18px', marginBottom: 10, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 14, opacity: loading && loading !== 'event' ? 0.5 : 1 }}>
          <div style={{ fontSize: 28, flexShrink: 0 }}>🎉</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.white }}>Event Pass</div>
            <div style={{ fontSize: 15, color: C.textSub, marginTop: 2 }}>Unlimited players · 24 hours</div>
          </div>
          <div style={{ textAlign: 'right', flexShrink: 0 }}>
            <div style={{ fontSize: 18, fontWeight: 900, color: C.green, lineHeight: 1 }}>{loading === 'event' ? '...' : '£3.99'}</div>
            <div style={{ fontSize: 13, color: C.textSub, fontWeight: 700, marginTop: 2 }}>one-off</div>
          </div>
        </div>

        {/* Unlimited — £24.99 / month */}
        <div onClick={() => !loading && handlePay('unlimited')} style={{ background: C.card, border: `2px solid ${C.gold}70`, borderRadius: 16, padding: '16px 18px', marginBottom: 20, cursor: 'pointer', position: 'relative', overflow: 'hidden', opacity: loading && loading !== 'unlimited' ? 0.5 : 1 }}>
          <div style={{ position: 'absolute', top: 0, right: 0, background: C.gold, color: '#000', fontSize: 13, fontWeight: 900, padding: '4px 12px', borderBottomLeftRadius: 10 }}>🔥 BEST FOR REGULARS</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 6 }}>
            <div style={{ fontSize: 28, flexShrink: 0 }}>♾️</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: C.white }}>Unlimited</div>
              <div style={{ fontSize: 15, color: C.textSub, marginTop: 2 }}>Unlimited players · every event</div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{ fontSize: 18, fontWeight: 900, color: C.gold, lineHeight: 1 }}>{loading === 'unlimited' ? '...' : '£24.99'}</div>
              <div style={{ fontSize: 13, color: C.textSub, fontWeight: 700, marginTop: 2 }}>/ month</div>
            </div>
          </div>
        </div>

        {/* Trust line: cancel anytime + refund policy */}
        <div style={{ textAlign: 'center', fontSize: 15, color: C.textMuted, marginBottom: 14 }}>
          Cancel anytime ·{' '}
          <a href="/refunds.html" target="_blank" rel="noopener noreferrer" style={{ color: C.textSub, fontWeight: 700, textDecoration: 'underline' }}>Refund policy</a>
        </div>

        {/* Maybe later */}
        <div style={{ textAlign: 'center' }}>
          <div onClick={onClose} style={{ fontSize: 15, color: C.textMuted, cursor: 'pointer', textDecoration: 'underline' }}>
            Maybe later
          </div>
        </div>

      </div>
    </div>
  );
}

export default Pricing;